import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('benefits_sets_approval', '/benefits_sets_approve', 'approval')
const actions = generator.generate()

export default actions
